<template>
  <div id="contact">
    <div class="content">
      <div class="content__inner">
        <h2 class="text-title">{{ getOption('cp_header') }}</h2>
        <p>{{ getOption('cp_lead_text') }}</p>
        <div class="contact-form">
          <form v-on:submit.prevent="submitForm" autocomplete="on">
            <label for="name">Your Name</label>
            <input
              v-model="name.val"
              type="text"
              id="name"
              name="name"
              placeholder=""
              required
            />
            <label for="email">Your Email</label>
            <input
              v-model="email.val"
              type="email"
              id="email"
              name="email"
              placeholder=""
              required
            />
            <label for="message">Your Message</label>
            <textarea
              v-model="message.val"
              id="message"
              name="message"
              placeholder=""
              required
            ></textarea>
            <input type="submit" class="btn btn--small" value="Say Hello" />
          </form>
        </div>
        <div
          id="form-feedback-msg"
          class="display-msg"
          v-bind:class="{ show: formSubmitted, error: hasError }"
        >
          <p>{{ displayMsg }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GetOption from '../mixins/GetOption';

export default {
  name: 'Contact',
  mixins: [GetOption],
  data() {
    return {
      name: {
        id: 1237223573,
        val: '',
      },
      email: {
        id: 629816561,
        val: '',
      },
      message: {
        id: 434961154,
        val: '',
      },
      displayMsg: '',
      formSubmitted: false,
      hasError: false,
    };
  },
  methods: {
    submitForm() {
      this.formSubmitted = false;
      this.hasError = false;

      let data = {
        name: {
          id: 1237223573,
          // id: 1175724924,
          val: this.name.val,
        },
        email: {
          id: 629816561,
          // id: 1209588789,
          val: this.email.val,
        },
        message: {
          id: 434961154,
          // id: 993297357,
          val: this.message.val,
        },
      };

      this.$http
        .post(
          'https://docs.google.com/forms/d/e/1FAIpQLSeEpQsUlgDCdtZI-AxLSjpMkKifnSwEGiekbrYOsZerMtMfmw/formResponse?',
          this.parameterize(data),
          {
            headers: {
              'Content-Type':
                'application/x-www-form-urlencoded; charset=UTF-8',
            },
          }
        )
        .then(
          (response) => {
            console.log('success :: ', response);
            this.formSubmitted = true;
            if (response.status === 200) {
              this.displayMsg =
                "Thanks for dropping a line! I'll get back to you soon.";
              this.name.val = this.email.val = this.message.val = '';
            } else {
              this.hasError = true;
              this.displayMsg =
                'Uh oh, something went wrong! Please give it another go.';
            }
            this.scrollToMsg();
          },
          (error) => {
            // console.log('error :: ', error);
            // CORS error from a google form will happen even on success and have status: 0
            // This is expected, and actually means that the form submission was successful
            if (error.status === 0) {
              this.formSubmitted = true;
              this.displayMsg =
                "Thanks for dropping a line! I'll get back to you soon.";
              this.name.val = this.email.val = this.message.val = '';
            } else {
              this.hasError = true;
              this.displayMsg =
                'Uh oh, something went wrong! Please give it another go.';
            }
            this.scrollToMsg();
          }
        );
    },
    parameterize(data) {
      let returnString = '';
      let d;

      for (d in data) {
        returnString += '&entry.' + data[d].id + '=' + data[d].val;
      }

      return returnString;
    },
    scrollToMsg() {
      var el = document.getElementById('form-feedback-msg');
      el.scrollIntoView({
        behavior: 'smooth',
      });
    },
  },
};
</script>
